import { render, staticRenderFns } from "./loadingView.vue?vue&type=template&id=1130349e&scoped=true"
import script from "./loadingView.vue?vue&type=script&lang=js"
export * from "./loadingView.vue?vue&type=script&lang=js"
import style0 from "./loadingView.vue?vue&type=style&index=0&id=1130349e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130349e",
  null
  
)

export default component.exports